import * as UploadApi from '../api/UploadMediaRequest.js'

export const uploadMedia = (data) => async(dispatch)=> {
    try {
        await UploadApi.uploadImage(data);
    } catch (error) {
        console.log(error);
    }
}